<template>
    <div>
        <ActiveClientList
            v-if="reportId == CREPORT.TYPE.ACTIVE_CLIENT_LIST"
            :data="data"
        />

        <ActiveClientSummary
            v-if="reportId == CREPORT.TYPE.ACTIVE_CLIENTS"
            :data="data"
        />

        <ActiveEngagedClientList
            v-if="reportId == CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST"
            :data="data"
        />

        <CardsStoredOnFile
            v-if="reportId == CREPORT.TYPE.CARDS_STORED_ON_FILE"
            :data="data"
        />
        <TotalBilledAndCollected
            v-if="reportId == CREPORT.TYPE.TOTAL_BILLED_AND_COLLECTED"
            :data="data"
        />
        <NewEngagedClients
            v-if="reportId == CREPORT.TYPE.NEW_ENGAGED_CLIENTS"
            :data="data"
        />
        <PetCareClientList
            v-if="reportId == CREPORT.TYPE.PETCARE_CLIENT_LIST"
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import ActiveClientList from "@/module/report/module/client/active-client-list";
import ActiveEngagedClientList from "@/module/report/module/client/active-engaged-client-list";
import ActiveClientSummary from "@/module/report/module/client/active-client-summary";
import CardsStoredOnFile from "@/components/report-client/cards-stored-on-file.vue";
import TotalBilledAndCollected from "@/components/report-client/total-billed-and-collected.vue";
import NewEngagedClients from "@/module/report/module/client/new-engaged-clients";
import PetCareClientList from "@/module/report/module/client/petcare-client-list";

export default {
    components: {
        ActiveClientList,
        ActiveClientSummary,
        ActiveEngagedClientList,
        CardsStoredOnFile,
        TotalBilledAndCollected,
        NewEngagedClients,
        PetCareClientList
    },
    props: {
        data: {
            default() {},
            type: Object
        }
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
